/**
 * Description:
 * Author: Wangyan
 * Date: 2019-03-28
 * Time: 15:22
 */

// global.firstUnit = '370600000000'
global.firstUnit = '420000000000'

// 行政审批提交部门（法制总队）
global.xzspDept = '420000210000'
